import type { ReleaseRegressionConfig } from './releaseTypes';

export function getReleaseRegressionScopeLabel(
  regressionConfig: ReleaseRegressionConfig | null | undefined,
  // "Run all" targets eligible flows on the eligibility model (flag ON) and promoted flows
  // on the legacy promotion model (flag OFF); default false keeps today's promotion wording.
  eligibilityModel = false
) {
  if (!regressionConfig) return 'Configured workflow suite';
  if (regressionConfig.selectionMode === 'tag') {
    return regressionConfig.tags.length > 0
      ? `Workflows tagged ${regressionConfig.tags.join(', ')}`
      : 'Tagged workflows';
  }
  return `All ${eligibilityModel ? 'eligible' : 'promoted'} workflows for this application`;
}
